import { render, staticRenderFns } from "./progress_bar.vue?vue&type=template&id=45e5f890&scoped=true&"
import script from "./progress_bar.vue?vue&type=script&lang=js&"
export * from "./progress_bar.vue?vue&type=script&lang=js&"
import style0 from "./progress_bar.vue?vue&type=style&index=0&id=45e5f890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5f890",
  null
  
)

export default component.exports